<template>
    <div class="mead-info-pill f fh fj-sb fa-c sm-r-s bf br-l sp-xs">
        <p class="sm-l-xs" :class="uiShowRemove ? 'sm-r-s' : 'sm-r-xs'">{{ uiLabel | athT }}</p>
        <ButtonPill v-if="uiShowRemove"
            :icon="uiIcon"
            :title="'mead.remove'"
            @click="onRemoveClicked" />
    </div>
</template>
<script>
import ButtonPill from '../ButtonPill.vue'

export default {
    name: 'mead-info-pill',
    props: {
        /**
         * Text label displayed in the pill, passed through the `athT` translation
         * filter.
         */
        uiLabel: {type: String, default: ''},
        /**
         * Whether to show the remove (pill) button that emits `onRemove` when clicked.
         */
        uiShowRemove: {type: Boolean, default: true},
        /**
         * Name of the icon shown on the remove button.
         */
        uiIcon: {type: String, default: 'cross'}
    },
    components: {ButtonPill},
    methods: {
        onRemoveClicked: function () {
            this.$emit('onRemove');
        }
    }
}
</script>